import moment from "moment"

export const categories = {
    Assets: ['Other Assets', 'Accounts Receivable', 'Other Current Assets', 'Cash', 'Bank', 'Fixed Assets', 'Stock', 'Payment Clearing'],
    Liabilities: ['Accounts Payable', 'Other Current Liabilities', 'Credit Cards', 'Long Term Liabilities', 'Other Liabilities'],
    Equity: ['Equity'],
    Income: ['Income', 'Other Income'],
    Expenses: ['Expenses', 'Cost of Goods Sold', 'Other Expenses']
}

export const departments = ['front-desk', 'records', 'cashier', 'triage', 'consultation', 'lab', 'radiography', 'sonography', 'nursing', 'physiotherapy', 'stock-take', 'trauma', 'dental', 'optical', 'marketing', 'theatre', 'inpatient', 'pharmacy', 'store', 'procurement', 'credit-control', 'credit-patient-docs', 'reports', 'sales', 'documents', 'human-resources', 'accounts', 'admin']

export const rangePresets = {
    'Today': [moment().startOf('day'), moment().endOf('day')],
    'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
    'This Week': [moment().startOf('week'), moment().endOf('week')],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
}

let types = []
for (let cat in categories)
    types.push({
        label: cat,
        options: categories[cat].map(type => ({
            label: type,
            value: type
        }))
    })

export const accountTypes = types